import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import FaqSection from '../components/FaqSection';
import { initAnalytics, trackUserJourney } from '../utils/analytics';

const FaqPage = () => {
  useEffect(() => {
    const cleanup = initAnalytics('faq_page');
    trackUserJourney('faq_page_visit', 'support');
    return cleanup;
  }, []);

  return (
    <>
      <Helmet>
        <title>FAQ Sun Spot - Questions sur les spots panoramiques et points de vue</title>
        <meta name="description" content="Questions fréquentes Sun Spot : comment découvrir des spots panoramiques, partager vos lieux avec vue préférés, et rejoindre la communauté des amoureux de beaux paysages." />
        <link rel="canonical" href="https://sun-spot.app/faq" />
        <meta property="og:url" content="https://sun-spot.app/faq" />
        <meta property="og:title" content="FAQ Sun Spot - Questions fréquentes" />
        <meta property="og:description" content="Réponses aux questions fréquentes sur Sun Spot et la découverte de spots panoramiques exceptionnels." />
      </Helmet>
      
      <div className="pt-16">
        <FaqSection />
      </div>
    </>
  );
};

export default FaqPage;